import {MessageContentType} from '@models/adminstration/machine/trigger/trigger-query/message-content-type';
import {
  AdditionalMessageField
} from '@models/adminstration/machine/trigger/trigger-query/additional-message-field/additional-message-field';

export class TriggerQueryAction {
  email: string;
  newSubscriber: string;
  subscriberList: string[];
  subject: string;
  message: string;
  topic: string | null;
  messageContentType: MessageContentType;
  additionalMessageFields: AdditionalMessageField[] | null;

  constructor(triggerQueryAction?: TriggerQueryAction) {
    this.email = triggerQueryAction?.email || '';
    this.newSubscriber = triggerQueryAction?.newSubscriber || '';
    this.subscriberList = triggerQueryAction?.subscriberList || new Array<string>();
    this.subject = triggerQueryAction?.subject || '';
    this.message = triggerQueryAction?.message || '';
    this.topic = triggerQueryAction?.topic || '';
    this.messageContentType = triggerQueryAction?.messageContentType || MessageContentType.TEXT;
    this.additionalMessageFields = triggerQueryAction?.additionalMessageFields || null;
  }
}
